import * as React from 'react';
import SunWidget from './SunWidget';
import ForecastWidget from './ForecastWidget';
import { Paper } from '@mui/material';
import { formatDate, Translate } from '../../../../../shared/LanguageService';

export type WeatherForecast = {
    precipitation: number;
    skyIcon: string;
    time: string;
};

export type WeatherWidgetLabels = {
    source: string;
    infoMessage: string;
    notAvailable: string;
    noWeatherInfo: string;
};

export type WeatherWidgetProps = {
    city: string;
    weatherForecasts: WeatherForecast[];
    sunrise: string;
    sunset: string;
    labels: WeatherWidgetLabels;
};

export const WeatherWidget = (props: WeatherWidgetProps) => {
    let { city, weatherForecasts, sunrise, sunset, labels } = props;
    return (
        <Paper
            sx={{
                maxWidth: '320px',
                padding: '16px',
                border: '1px solid rgba(0, 0, 0, 0.12)',
                boxShadow: 'none'
            }}
        >
            <ForecastWidget selectedForecasts={weatherForecasts} city={city} labels={labels} />
            <SunWidget sunrise={sunrise} sunset={sunset} labels={labels} />
        </Paper>
    );
};

function WeatherWidgetTranslationLayer(props) {
    let labels: WeatherWidgetLabels = {
        source: Translate('weather/sun-widget/source'),
        infoMessage: Translate('weather/sun-widget/info-message'),
        notAvailable: Translate('weather/sun-widget/not-available'),
        noWeatherInfo: Translate('weather/sun-widget/no-weather-info')
    };
    return <WeatherWidget {...props} labels={labels} />;
}

const WeatherWidgetDataLayer = (props) => {
    let { sunset, sunrise } = props;

    let formattedSunrise = sunrise ? formatDate(new Date(sunrise), 'HH:mm') : null;
    let formattedSunset = sunrise ? formatDate(new Date(sunset), 'HH:mm') : null;

    let selectedForecasts = props.weatherForecasts
        ? props.weatherForecasts.filter((forecast: any) => {
              let hour = new Date(forecast.time.replace('Z', '')).getHours();
              return hour === 6 || hour === 12 || hour === 18;
          })
        : [];

    return (
        <WeatherWidgetTranslationLayer
            {...props}
            sunset={formattedSunset}
            sunrise={formattedSunrise}
            weatherForecasts={selectedForecasts}
        />
    );
};
export default WeatherWidgetDataLayer;
